import vhCheck from 'vh-check';
vhCheck();

// Components
import './components/header';

// Modules
import './modules/marquee';

// Sections
import './sections/faq';
import './sections/components';
import './sections/customer';

// Snippets
import './snippets/country-selector';
import './snippets/multi-range';
import './snippets/images';
import './snippets/videos';
// import './snippets/flickity';

initPolicyPages();
function initPolicyPages() {
  const policyBody = document.querySelector('.shopify-policy__body');
  if (!policyBody) return;

  // Find all <ol> with class that starts with "start-" and replace that with a start attribute
  const ol = policyBody.querySelectorAll('ol[class*="start-"], ol[class*="type-"]');
  ol.forEach((list) => {
    const classes = list.className.split(' ');
    classes.forEach((c) => {
      // console.log(c);
      if (c.startsWith('start-')) {
        const start = c.split('start-')[1];
        list.setAttribute('start', start);
      }

      if (c.startsWith('type-')) {
        const type = c.split('type-')[1];
        list.setAttribute('type', type);
      }
    });

    // const start = list.className.split('start-')[1].split(' ')[0];
    // list.setAttribute('start', start);
  });

  // Find all <ol> with class that includes "type-" and replace with a type attribute
  // const olType = policyBody.querySelectorAll('ol[class*="type-"]');
  // olType.forEach((list) => {
  //   console.log(list.className);
  //   const type = list.className.split('type-')[1].split(' ')[0];
  //   list.setAttribute('type', type);
  // });
}
